import React, { ReactNode } from 'react';

import { Box, COLORS, Text } from '@clutter/clean';

import { Block } from '@shared/page_builder/block';

export const InfoCardList: React.FC<{
  title: ReactNode;
  children: ReactNode;
}> = ({ title, children }) => (
  <Block background={COLORS.grayBackground}>
    <Box textAlign="center" margin="0 0 48px">
      <Text.Title size="large">{title}</Text.Title>
    </Box>
    <Box.Flex
      textAlign="center"
      gap="24px"
      flexDirection={['column', null, 'row']}
    >
      {children}
    </Box.Flex>
  </Block>
);
